import styled from "styled-components";

export const TooltipWrapper = styled.div`
  margin: 0;
  border: 1px solid #f5f5f5;
  background-color: #f3f4f5;
  border-radius: 5px;
  padding: 5px;
`
export const StyledSkeletonWrapper = styled.div`
padding: 1.25em 2em;
.skeleton-chart {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
  height: 300px; 
  width: 100%;
  padding: 20px;
  background-color: #f5f5f5; 
  position: relative;
  overflow: hidden;
}

.skeleton-bar {
  width: 70px;
  background: linear-gradient(90deg, #e0e0e0 25%, #d6d6d6 50%, #e0e0e0 75%);
  background-size: 400% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.bar1 { height: 40%; }
.bar2 { height: 60%; }
.bar3 { height: 30%; }

@keyframes loading {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
`